import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollLayoutTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

export default ScrollLayoutTop;
